const moment = require('moment-timezone');

export const OPENING_HOUR = moment.utc('01:30 AM', 'hh:mm');
export const CLOSED_HOUR = moment.utc('10:30 AM', 'hh:mm');
export const getCountryZone = (region) => {
  const country = moment.tz.zonesForCountry(region)[0];
  const zone = moment.tz(country).format('Z');
  return ({ country, zone });
};



// WEBPACK FOOTER //
// ../src/constants/operating.js